/**
 * 会社ピッカーで「＋ 新しい会社として登録」行を出すか判定する純粋関数。
 *
 * - 2文字未満は出さない（search RPC が 2文字未満で空を返す＝候補が出ない段階で
 *   作成だけ先に出すと重複乱用を招くため。閾値を検索と揃える）
 * - 入力と完全一致（前後空白を無視）の候補が既にあれば出さない（既存優先）
 *
 * 注: ここでの「完全一致」はクライアント側の素朴な文字列一致。最終的な重複判定は
 * サーバ側の normalize_company_name による正規化解決に委ねる（表記ゆれは吸収される）。
 */
export function shouldOfferCreate(query: string, companies: {name: string}[]): boolean {
  const q = query.trim();
  if (q.length < 2) return false;
  return !companies.some((c) => c.name.trim() === q);
}
